import reframe from 'reframe.js';

export function initReframe() {
  reframe('iframe[src*="youtube.com"');
  reframe('iframe[src*="youtube-nocookie.com"');
  reframe('iframe[src*="vimeo.com"]');
}
